import {ShapeCommand} from '../commands.template';
import * as _ from 'lodash';

export class ImageChangeCommand extends ShapeCommand {
  services: any;
  original;
  modified;
  constructor(data, modifications) {
    super(data);
    this.original = _.cloneDeep(data);
    this.modified = _.assign(_.cloneDeep(data), modifications);
  }

  changeImageRequest(data) {
    const keys = ['mxKey', 'position', 'link', 'lock'];
    const payload = _.pick(data, keys);

    return this.services.diagramUpdateSvc.update({
      changeImage: payload
    });
  }

  public execute() {
    super.execute();

    return this.changeImageRequest(this.modified);
  }

  public reverse() {
    super.reverse();

    return this.changeImageRequest(this.original);
  }
}
